<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    title="草稿箱"
    namespace="wechat_third_party_platform/"
    resource="draft_templates"
    :actionButtons="[]"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class DraftTemplate extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns() {
    return [
      {
        prop: 'user_version',
        label: '版本号'
      },
      {
        prop: 'user_desc',
        label: '描述',
        width: 400
      },
      {
        prop: 'source_miniprogram',
        label: '来源小程序'
      },
      {
        prop: 'developer',
        label: '上传开发者'
      },
      {
        prop: 'create_time',
        label: '最近提交时间',
        renderCell: 'time'
      }
    ];
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }) {
    const handleAddToTemplate = async (id) => {
      await this.$autoLoading(this.$request.post(`/wechat_third_party_platform/draft_templates/${id}/add_to_template`));
      this.$message.success('添加成功');
    }

    return [
      {
        component: 'confirmButton',
        props: {
          label: '添加到模板库',
          type: 'primary',
          can: 'draft_templates.add_to_template'
        },
        on: {
          confirm: () => handleAddToTemplate(row.id)
        }
      }
    ];
  }
}


export const route = [
  {
    path: '/draft_templates',
    name: 'draft_templates.index',
    component: DraftTemplate,
    props: {
      type: 'index',
    }
  },
]
</script>
